import { render, staticRenderFns } from "./InventoryAdjustments.vue?vue&type=template&id=364e8e48"
import script from "./InventoryAdjustments.vue?vue&type=script&lang=js"
export * from "./InventoryAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports